import http from 'utils/http';

export const getNotPrintedBarcodes = (payload) => {
  return http.get('/barcode/notPrinted', payload);
};

export const getPrintedBarcodes = (payload) => {
  return http.get('/barcode/printed', payload);
};
